import { openDB } from 'idb';
import { getCookieToken } from '../../utils/cookieToken'

import * as ApiBase from '../../APIBase'
import {
  syncWishlistedProducts,
  deleteWishlistedProduct,
  wishlistLoading
} from './index'


export const setCurrency = (country) => {
  let currency = ''
  switch (country) {
    case 'IN':
      currency = 'INR'
      break
    case 'HK':
      currency = 'HKD'
      break
    case 'SG':
      currency = 'SGD'
      break
    case 'MY':
      currency = 'MYR'
      break
    default:
      currency = 'INR'
  }
  return currency
}

export const removeWishlistedProduct = (product) => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const accessToken = getState().user.accessToken
  const URL = `/${subPath}/customer/wishlist`

  await ApiBase.del(URL, { delWProducts: [...product] }, accessToken)

  dispatch(deleteWishlistedProduct(product))
}


export const fetchWishlistedProducts = ({ page }) => async (dispatch, getState) => {
  dispatch(wishlistLoading({ loading: true }))

  const token = getState().user.accessToken || getCookieToken()
  const subPath = getState().merchant.canonical_name
  const URL = `/${subPath}/customer/wishlist`

  const json = await ApiBase.get(URL, { page }, token)
  if (json.success) {
    dispatch(wishlistLoading({ loading: false, message: '' }))
    const currency = setCurrency(getState().merchant.home_country)
    const wishlistedUserData = json.data.map(wData => {
      return {
        ...wData,
        sync: true,
        currency
      }
    })

    const wProductData = {
      data: wishlistedUserData,
      pagination: json.pagination
    }
  
    await openDB('merchantStore', 1, {

    }).then(async (db) => {
      const tx = db.transaction('buyerWishlist', 'readwrite')
      
      Promise.all(wishlistedUserData.map(wData => tx.store.put({
        ...wData,
      })))
    })

    dispatch(syncWishlistedProducts(wProductData))
  }
}

export const syncWishlistedProductsToStore = () => async (dispatch, getState) => {

  const token = getState().user.accessToken || getCookieToken()
  const subPath = getState().merchant.canonical_name
  const URL = `/${subPath}/customer/wishlist`

  dispatch(wishlistLoading({ loading: true }))

  await openDB('merchantStore', 1, {
    upgrade(db) {
      db.createObjectStore('buyerWishlist', { keyPath: 'id' })
    },
  }).then((db) => {
    const tx = db.transaction('buyerWishlist', 'readwrite')
    const store = tx.objectStore('buyerWishlist')

    return store.getAll()
  }).then(async (details) => {
    let productsToSync = []
    if (details.length) {
      productsToSync = details
        .filter(item => item.sync === false)
        .map(item => {
          return {
            ...item,
            sync: true,
          }
        })
      
      if (productsToSync.length) {
        await ApiBase.post(URL, {
          addWProducts: [...productsToSync],
        }, token )
      }
    }
    return details
  })

  dispatch(wishlistLoading({ loading: true, message: 'Fetching Wishlist...may take a while.' }))
  const json = await ApiBase.get(URL, { page : 1 }, token)
  if (json.success) {
    dispatch(wishlistLoading({ loading: false, message: '' }))
    const currency = setCurrency(getState().merchant.home_country)
    debugger
    const wishlistedUserData = json.data.map(wData => {
      return {
        ...wData,
        sync: true,
        currency
      }
    })

    const wProductData = {
      data: wishlistedUserData,
      pagination: json.pagination
    } 

    await openDB('merchantStore', 1, {

    }).then(async (db) => {
      const tx = db.transaction('buyerWishlist', 'readwrite')

      Promise.all(wishlistedUserData.map(wData => tx.store.put({
        ...wData,
      })))
    })
    dispatch(syncWishlistedProducts(wProductData))
  }
}
